import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col } from "antd";
import _ from "lodash";
import {
  AddRSVPModal,
  PeopleModal,
  SelectDateTimeModal,
  UploadFileModal,
  GPSModal,
  GPSReportModal,
  RXSensorModal,
  PageSummaryModal,
  VideoRecorderModal,
  IoTAlertModal,
  AddPayModal,
  UploadSignatureModal,
} from ".";
import AddEventModal from "./AddEventModal";
import { useDispatch } from "react-redux";
import Geocode from "react-geocode";
import AddIoTModal from "./AddIoTModal";
import { AddSurveyModal } from "components/Modals";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { popupCenter } from "utils/appUtil";
import {
  wrapRequestPayload,
} from "../../helpers/request/RequestPayload";
import { SocketTopics } from "../../constants/enums";
import {
  getSendAssistLinkPublishTopic,
} from "hooks/MQTTConstants";
import { pushNotification } from "utils/notifications";



Geocode.setApiKey("AIzaSyDgNagv_ozKWc6IQ75Ol4cH8fxdntOaW6M");
Geocode.setLanguage("en");
Geocode.setRegion("us");
const ICONS: PopupModelIcon = {
  FILTER: [
    { key: "Media", value: "media", selected: false },
    { key: "Pay", value: "pay", selected: false },
    { key: "Event", value: "event", selected: false },
    { key: "Place", value: "place", selected: false },
    { key: "IoT", value: "iot", selected: false },
    { key: "Capture", value: "capture", selected: false },
    { key: "Incident", value: "incident", selected: false },
    { key: "RSVP", value: "rsvp", selected: false },
    { key: "People", value: "people", selected: false },
    { key: "Text", value: "text", selected: false },
    { key: "Alert", value: "alert", selected: false },
    { key: "IoT File", value: "gps-report", selected: false },
    { key: "GPS live", value: "gps", selected: false },
  ],
  MESSAGE: [
    { key: "Place", value: "Place" },
    { key: "Signature", value: "File" },
    { key: "RSVP", value: "RSVP" },
    { key: "Event", value: "Event" },
    { key: "People", value: "People" },
    { key: "Alert", value: "Alert" },
    { key: "Pay", value: "Pay" },
    { key: "Summary", value: "summary" },
    { key: "Survey", value: "Survey" },
    { key: "Incident", value: "incident" },
    { key: "Emergency", value: "emergency" },
    { key: "RX Sensor", value: "RX Sensor" },
  ],
  UPLOAD: [
    { key: "Image", value: "Image" },
    { key: "Audio", value: "Audio" },
    { key: "Video", value: "media" },
    { key: "IoT File", value: "iot" },
    { key: "Diagram", value: "Survey" },
  ],
};

/*global google*/
const PopupModal: FC<{
  type?: string;
  onClose?: () => void;
  socket?: ISocket;
  onClick?: any;
}> = ({ type, onClose, socket, onClick }) => {
  const [options, setOptions] = useState<
    PopupModelFilterIcon[] | PopupModelMessageIcon[]
  >(type === "MESSAGE" ? ICONS["MESSAGE"] : type === "UPLOAD" ? ICONS["UPLOAD"] : ICONS["FILTER"]);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [filePopupDisplayed, setFilePopupDisplayed] = useState<boolean>(false);
  const [iotPopupDisplayed, setIotPopupDisplayed] = useState<boolean>(false);
  const [peoplePopupDisplayed, setPeoplePopupDisplayed] =
    useState<boolean>(false);
  const [rsvpPopupDisplayed, setRSVPPopupDisplayed] = useState<boolean>(false);
  const [dateTimePopupDisplayed, setDateTimePopupDisplayed] =
    useState<boolean>(false);
  const [addEventPopupDisplayed, setAddEventPopupDisplayed] =
    useState<boolean>(false);
  const [addPayPopupDisplayed, setAddPayPopupDisplayed] =
    useState<boolean>(false);
  const [addSignaturePopupDisplayed, setAddSignaturePopupDisplayed] =
    useState<boolean>(false);
  const [addGPSDisplayed, setAddGPSDisplayed] = useState<boolean>(false);
  const [addGPSReportDisplayed, setAddGPSReportDisplayed] =
    useState<boolean>(false);
  const [addRxSensorDisplayed, setAddRxSensorDisplayed] =
    useState<boolean>(false);
  const [addPageSummaryDisplayed, setAddPageSummaryDisplayed] =
    useState<boolean>(false);
  const [addVideoRecorderDisplayed, setAddVideoRecorderDisplayed] =
    useState<boolean>(false);
  const [addIoTAlertDisplayed, setAddIoTAlertDisplayed] =
    useState<boolean>(false);
  const [summaryModalDisplayed, setSummaryModalDisplayed] = useState(false);
  const [surveyModalDisplayed, setSurveyModalDisplayed] = useState(false);
  const dispatch = useDispatch();
  const { selectedItem } = useSelector((state: RootState) => state.search);
  const { messageFilter } = useSelector((state: RootState) => state.message);

  const handleCancel = () => {
    onClose && onClose();
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (messageFilter && messageFilter.length > 0) {
      console.log('tets', messageFilter);
      let updatedOptions = [...options];




      updatedOptions = updatedOptions.map((option) =>
        messageFilter.includes(option.value)
          ? { ...option, selected: true }
          : { ...option }
      );

      setOptions([...updatedOptions]);
    }
  }, []);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const selectType = (selectedType: string) => {
    if(type === "UPLOAD"){
      onClick && onClick(selectedType);
      return;
    }
    if (type === "MESSAGE") {
      if (selectedType === "File") {
        setAddSignaturePopupDisplayed(true);
        return;
      }
      if (selectedType === "IoT") {
        return;
      }
      if (selectedType === "RSVP") {
        setRSVPPopupDisplayed(true);
        return;
      }
      if (selectedType === "People") {
        setPeoplePopupDisplayed(true);
        return;
      }
      if (selectedType === "Event") {
        setAddEventPopupDisplayed(true);
        return;
      }
      if (selectedType === "Pay") {
        setAddPayPopupDisplayed(true);
        return;
      }
      if (selectedType === "Media") {
        setFilePopupDisplayed(true);
        return;
      }
      if (selectedType === "GPS Live") {
        setAddGPSDisplayed(true);
        return;
      }
      if (selectedType === "GPS Report") {
        setAddGPSReportDisplayed(true);
        return;
      }
      if (selectedType === "RX Sensor") {
        setAddRxSensorDisplayed(true);
        return;
      }
      if (selectedType === "Page Summary") {
        setAddPageSummaryDisplayed(true);
        return;
      }
      if (selectedType === "Video Detector") {
        setAddVideoRecorderDisplayed(true);
        return;
      }
      if (selectedType === "summary") {
        popupCenter(
          `${process.env.REACT_APP_SHARED_URI}/${selectedItem?.persistent?.static?.profile?.summary ?? "summary"
          }?connectionId=${localStorage.getItem("CID")}&pageId=${selectedItem.pageId
          }&cudbServiceId=${selectedItem?.persistent?.static?.iotAsset?.config
            ?.configUserCudbServiceId
          }`,
          "Summary",
          window.innerWidth * 0.7,
          window.innerHeight * 0.9
        );

        return;
      }

      if (selectedType === "Survey") {
        popupCenter(
          `${process.env.REACT_APP_SHARED_URI}/survey?mode=edit&userId=${selectedItem?.persistent?.static?.iotAsset?.config?.configUserId
          }&projectId=${selectedItem?.persistent?.static?.iotAsset?.config?.iotAssetConfigId
          }&type=survey&cudbServiceId=${selectedItem?.persistent?.static?.iotAsset?.config
            ?.configUserCudbServiceId
          }&connectionId=${localStorage.getItem(
            "CID"
          )}&liveUserId=${localStorage.getItem("RID")}&pageId=${selectedItem.pageId
          }`,
          "Survey",
          window.innerWidth * 0.7,
          window.innerHeight * 0.9
        );

        return;
      }

      if (selectedType === "incident") {
        popupCenter(
          `${process.env.REACT_APP_SHARED_URI
          }/cpc?connectionId=${localStorage.getItem(
            "CID"
          )}&userId=${localStorage.getItem("RID")}&assistPageId=${selectedItem.pageId
          }`,
          "CPC",
          window.innerWidth * 0.7,
          window.innerHeight * 0.9
        );
        return;
      }

      if (selectedType === 'emergency') {
        if (window.confirm("Are yo usure you want to send emergency message?") == true) {
          console.log('send link here');
          socket.publishToEvent(
            SocketTopics.PublishPageTopics,
            getSendAssistLinkPublishTopic(),
            wrapRequestPayload({
              pageId: selectedItem.pageId,
            })
          );
          pushNotification("Message sent successfully", "success", "TOP_CENTER", 1000);
        }
      }

      if (selectedType === "Survey") {
        setSurveyModalDisplayed(true);
        return;
      }
      if (selectedType === "Alert") {
        setAddIoTAlertDisplayed(true);
        return;
      }
      if (selectedType === "Place") {
        console.log("pace here");
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            getReverseGeocodingData(
              position.coords.latitude,
              position.coords.longitude
            );
          });
        } else {
          alert("Geolocation is not supported by this browser.");
        }
        return;
      }
      if (selectedType === "Capture") {
        dispatch({
          type: "SEND_MESSAGE",
          payload: { message: "Capture Item added", type: "Capture" },
        });
        return;
      }
    } else {
      const updatedOptions = options.map((option) =>
        option.value === selectedType
          ? { ...option, selected: !option.selected }
          : { ...option }
      );
      setOptions([...updatedOptions]);
      dispatch({
        type: "SET_MESSAGE_FILTER",
        payload: [...updatedOptions]
          .filter((x) => {
            return x.selected;
          })
          .map((x) => {
            return x.value;
          }),
      });
    }
  };

  const getReverseGeocodingData = (lat: number, lng: number) => {
    var latlng = new google.maps.LatLng(lat, lng);
    // This is making the Geocode request
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) {
        alert(status);
      }
      // This is checking to see if the Geoeode Status is OK before proceeding
      if (status == google.maps.GeocoderStatus.OK) {
        console.log(results);
        var address = results[0].formatted_address;
        console.log("add place here", address);
        dispatch({
          type: "SEND_MESSAGE",
          payload: {
            message: "My current location",
            type: "place",
            data: {
              attributes: {
                title: "My current location",
                address,
              },
              display: {
                type: "marker",
                color: "blue",
              },
              coordinates: {
                lat: lat,
                long: lng,
              },
            },
          },
        });
      }
    });
  };

  return (
    <div>
      <Modal
        title={type === "MESSAGE" ? "Action" : type === "UPLOAD" ? "Upload" : "Filter"}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={type === "MESSAGE" ? "372px" : "600px"}
        className="beam-modal"
        footer={[]}
        destroyOnClose={true}
      >
        <Row
          className={`d-flex popups m-col-${type === "MESSAGE" ? "9" : "15"}`}
        >
          {options.map((icon, idx) => (
            <React.Fragment key={idx}>
              {((type === 'UPLOAD' || 
                icon.value !== "summary" &&
                icon.value !== "Survey" &&
                icon.value !== "emergency" &&
                icon.value !== "incident") ||
                (icon.value === "summary" &&
                  selectedItem?.persistent?.static?.metadata?.type ===
                  "event") ||
                (icon.value === "Survey" &&
                  selectedItem?.persistent?.static?.iotAsset?.config
                    ?.iotAssetConfigId) ||
                (icon.value === "emergency" &&
                  selectedItem?.persistent?.static?.metadata?.type ===
                  "assist") ||
                (icon.value === "incident" &&
                  selectedItem?.persistent?.static?.metadata?.type ===
                  "assist" && selectedItem?.persistent?.static?.assist?.config?.configUserCudbServiceId)) && (
                  <Col key={idx} className="popup-item">
                    {icon.value !== "" && (
                      <>
                        <Button
                          className={`beam-btn${icon.selected ? " beam-filter-selected" : ""
                            }`}
                          onClick={() => selectType(icon.value)}
                        >
                          <img src={`/images/${icon.value}-icon.png`} />
                        </Button>
                        <p>{icon.key}</p>
                      </>
                    )}
                  </Col>
                )}
            </React.Fragment>
          ))}
        </Row>
      </Modal>
      {filePopupDisplayed && (
        <UploadFileModal onClose={() => setFilePopupDisplayed(false)} />
      )}
      {addSignaturePopupDisplayed && (
        <UploadSignatureModal
          onClose={() => setAddSignaturePopupDisplayed(false)}
        />
      )}
      {rsvpPopupDisplayed && (
        <AddRSVPModal onClose={() => setRSVPPopupDisplayed(false)} />
      )}
      {iotPopupDisplayed && (
        <AddIoTModal onClose={() => setIotPopupDisplayed(false)} />
      )}
      {peoplePopupDisplayed && (
        <PeopleModal
          socket={socket}
          onClose={() => {
            setPeoplePopupDisplayed(false);
            onClose && onClose();
          }}
        />
      )}
      {dateTimePopupDisplayed && (
        <SelectDateTimeModal onClose={() => setDateTimePopupDisplayed(false)} />
      )}
      {addEventPopupDisplayed && (
        <AddEventModal onClose={() => setAddEventPopupDisplayed(false)} />
      )}
      {addPayPopupDisplayed && (
        <AddPayModal onClose={() => setAddPayPopupDisplayed(false)} />
      )}
      {addGPSDisplayed && (
        <GPSModal onClose={() => setAddGPSDisplayed(false)} />
      )}
      {addGPSReportDisplayed && (
        <GPSReportModal onClose={() => setAddGPSReportDisplayed(false)} />
      )}
      {addRxSensorDisplayed && (
        <RXSensorModal onClose={() => setAddRxSensorDisplayed(false)} socket={socket} />
      )}
      {addPageSummaryDisplayed && (
        <PageSummaryModal onClose={() => setAddPageSummaryDisplayed(false)} />
      )}
      {addVideoRecorderDisplayed && (
        <VideoRecorderModal
          onClose={() => setAddVideoRecorderDisplayed(false)}
          socket={socket}
        />
      )}
      {addIoTAlertDisplayed && (
        <IoTAlertModal onClose={() => setAddIoTAlertDisplayed(false)} />
      )}

      {surveyModalDisplayed && (
        <AddSurveyModal onClose={() => setSurveyModalDisplayed(false)} />
      )}
    </div>
  );
};

export default PopupModal;
